import React from 'react'
import { ISchool } from '../interfaces/school.interface'
import { useSchoolDetails } from '../hooks/useSchoolDetails'
import SchoolMaterialThemeContainer from '../containers/SchoolMaterialThemeContainer'
import SchoolCourseDashboardView from '../views/School/SchoolCourseDashboardView'
import SchoolUserPageHead from '../components/SchoolUserPageHead'
import GlobalClientDashboardContainer from 'containers/Global/GlobalClientDashboardContainer'
import ErrorComponent from './_error'

const DashboardPage = (props: { schoolDetails: ISchool }) => {
  return (
    <GlobalClientDashboardContainer>
      <SchoolUserPageHead schoolDetails={props.schoolDetails} />
      <SchoolMaterialThemeContainer schoolDetails={props.schoolDetails}>
        <SchoolCourseDashboardView schoolDetails={props.schoolDetails} />
      </SchoolMaterialThemeContainer>
    </GlobalClientDashboardContainer>
  )
}

const DashboardWrapper: React.FC<any> = () => {
  const { loading, error, schoolDetails } = useSchoolDetails()

  if (error) {
    return <ErrorComponent statusCode={404} />
  }

  if (loading || !schoolDetails) {
    return null
  }

  return (
    <DashboardPage
      schoolDetails={schoolDetails}
    />
  )
}

export default DashboardWrapper
